import { createSelector } from '@reduxjs/toolkit';
import type { NameEntry } from './name-entry';
import { employeesNotDeleted } from 'src/store/selectors';
import type { EmployeeViewModel } from '@trinnvis/dabih-api-client';

export const employeesFullNames = createSelector(
  employeesNotDeleted,
  function (employees: EmployeeViewModel[]): NameEntry[] {
    return employees.map((e) => {
      return { uuid: e.uuid, name: [e.firstName, e.lastName].filter(Boolean).join(' '), status: e.status ?? '' };
    });
  },
);
